import { render, staticRenderFns } from "./affectations.vue?vue&type=template&id=29feef16&"
import script from "./affectations.vue?vue&type=script&lang=ts&"
export * from "./affectations.vue?vue&type=script&lang=ts&"
import style0 from "./affectations.vue?vue&type=style&index=0&id=29feef16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports